const ct = require('countries-and-timezones')

export const isStateFieldLocked = (overRide, country) => {
  let locked = false

  if (overRide === true) {
    return true
  }

  if (country === null || country === undefined || country === '') {
    return true
  }

  return locked
}

export const getCustomTimezone = (tz) => {
  let timezone = ''
  if (tz === 'America/Adak') {
    timezone = 'Pacific/Honolulu'
  } else if (tz === 'America/Anchorage') {
    timezone = 'America/Juneau'
  } else {
    timezone = tz
  }

  return timezone
}

export const timezoneOptionsFromCountry = (countryAbbr) => {
  let tzsToUse = []

  tzsToUse.push({ key: 0, text: 'Arizona Time', value: 'America/Phoenix' })
  tzsToUse.push({ key: 1, text: 'Alaskan Time', value: 'America/Juneau' })
  tzsToUse.push({ key: 2, text: 'Central Time', value: 'America/Chicago' })
  tzsToUse.push({ key: 3, text: 'Eastern Time', value: 'America/New_York' })
  tzsToUse.push({ key: 4, text: 'Hawaiian Time', value: 'Pacific/Honolulu' })
  tzsToUse.push({ key: 5, text: 'Mountain Time', value: 'America/Denver' })
  tzsToUse.push({ key: 6, text: 'Pacific Time', value: 'America/Los_Angeles' })

  // let timezoneOptions = []

  // let timeZonesRaw = ct.getTimezonesForCountry(countryAbbr)
  // let phoenixTz = timeZonesRaw.find((tz) => tz.name == 'America/Phoenix')
  // let phoenixTz = timeZonesRaw.find((tz) => tz.name == 'America/Phoenix')

  // tzsToUse.push({ label: 'Arizona Time', value: phoenixTz.name })
  // console.log('here it is', timeZonesRaw)
  // console.log('here it tzsToUse', tzsToUse)

  // let timeZonesRawLength = timeZonesRaw.length

  // for (let x = 0; x < timeZonesRawLength; x++) {
  //   if (informalSpace.display(timeZonesRaw[x].name)) {
  //     timezoneOptions.push({
  //       key: x,
  //       value: getCustomTimezone(timeZonesRaw[x].name),
  //       text: informalSpace.display(timeZonesRaw[x].name).standard
  //         ? informalSpace.display(timeZonesRaw[x].name).standard.name
  //         : timeZonesRaw[x].name,
  //     })
  //   }
  // }

  // let tzUnique = timezoneOptions.reduce((unique, o) => {
  //   if (!unique.some((obj) => obj.text === o.text)) {
  //     unique.push(o)
  //   }
  //   return unique
  // }, [])

  return tzsToUse
}
